import { render } from "./customer-details-invoice.vue?vue&type=template&id=285a2543"
import script from "./customer-details-invoice.vue?vue&type=script&lang=js"
export * from "./customer-details-invoice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__